var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React, { Component } from 'react';
import classnames from 'classnames/dedupe';
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
var BreadcrumbList = /** @class */function (_super) {
  __extends(BreadcrumbList, _super);
  function BreadcrumbList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BreadcrumbList.Item = function (_a) {
    var active = _a.active,
      children = _a.children,
      href = _a.href,
      dark = _a.dark;
    var className = 'breadcrumb-item text-white';
    if (active) {
      className = classnames(className, {
        'text-black': dark,
        'text-white': !dark,
        'text-shadow-light': dark,
        'text-shadow': !dark
      }, 'font-weight-bold active');
      return React.createElement("li", {
        className: className
      }, children);
    } else {
      var linkClassNames = classnames('rounded text-white font-weight-bold text-shadow text-decoration-none', {
        'bg-dark': dark
      });
      return React.createElement("li", {
        className: className
      }, React.createElement("a", {
        className: linkClassNames,
        href: href
      }, children));
    }
  };
  BreadcrumbList.prototype.render = function () {
    return React.createElement("nav", {
      "aria-label": 'breadcrumb'
    }, React.createElement("ol", {
      className: 'd-flex align-items-center justify-content-center justify-content-lg-start breadcrumb bg-transparent p-0 mb-0'
    }, this.props.children));
  };
  return BreadcrumbList;
}(Component);
export function HOBreadcrumbs(props) {
  var pathName = props.pathname;
  var pathNames = pathName.split('/').filter(Boolean);
  var breadCrumbs = pathNames.map(function (element, index) {
    var href = '/' + pathNames.slice(0, index + 1).join('/');
    return React.createElement(BreadcrumbList.Item, {
      key: index,
      active: index + 1 === pathNames.length,
      href: href,
      dark: props.dark
    }, capitalizeFirstLetter(element));
  });
  return React.createElement(BreadcrumbList, null, props.basePath && React.createElement(BreadcrumbList.Item, {
    active: false,
    href: '/',
    dark: props.dark
  }, props.basePath), breadCrumbs);
}